import { render, staticRenderFns } from "./PagamentoPendente.vue?vue&type=template&id=8fe45316&scoped=true"
import script from "./PagamentoPendente.vue?vue&type=script&lang=js"
export * from "./PagamentoPendente.vue?vue&type=script&lang=js"
import style0 from "./PagamentoPendente.vue?vue&type=style&index=0&id=8fe45316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe45316",
  null
  
)

export default component.exports